import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { thisBaseURL } from "../../utils/helper.js";
require("highcharts/modules/accessibility")(Highcharts);

Highcharts.setOptions({
    credits: { enabled: false },
    lang: {
      thousandsSep: ','
    }
  });
  
function AnnualProductionValue({foodAnswers, foodName}){
	let defaultSlug = foodAnswers.answerKeyValues["food_slug"];
	let productionValue = foodAnswers.answerKeyValues['u_s_production_value'];
	let productionValueYear = foodAnswers.answerKeyValues['u_s_production_value_year'];
	let productionValueSourceRef = foodAnswers.answerKeyValues['u_s_production_value_sources'];
	let productionValueNotes = foodAnswers.answerKeyValues['u_s_production_value_notes'];
	
	let array = [];
	let dataSeries = [];
	let xAxisCategories = [];
	let yAxisUSD = [];
	if (productionValue) {
		try {
			array = JSON.parse(productionValue);
		} catch (err) {
			console.log("AnnualProductionValue :productionValue: " + err);
		}
		dataSeries = array.map(function(obj) {
			if (obj && obj["year"] && obj["usd"]) {
				return [parseInt(obj["year"]), parseFloat(obj["usd"].replace(/,/g, ''))];
			} 
		});
		xAxisCategories = array.map(function(obj) {
			if (obj && obj["year"]) {
				return [parseInt(obj["year"])];
			} 
		});
		yAxisUSD = array.map(function(obj) {
			if (obj && obj["usd"]) {
				return [parseFloat(obj["usd"].replace(/,/g, ''))];
			} 
		});
	}
	let titleText = '';
	if(dataSeries && dataSeries.length > 0 && dataSeries[0]){
		titleText = 'Annual Value of  '+foodName+' Production in the United States ('+dataSeries[0][0]+' - '+dataSeries[dataSeries.length - 1][0]+")";
	}
	
            
	return(
			<div>
				{(dataSeries && dataSeries.length > 0 && dataSeries[0]) ? <><h2 style={{textAlign: "center"}}>
					{titleText}
					{ productionValueSourceRef && productionValueSourceRef > 0 ?
					<small className="superscript"><a href={thisBaseURL +"/foods/" +defaultSlug+"#"+productionValueSourceRef}>{productionValueSourceRef}</a></small>:
					""	
					}
				</h2>
				<HighchartsReact highcharts={Highcharts} containerProps={{ style: { width: "60vw" } }}
				options={{
					title: {
						text: ''
					},
					credits: {
						enabled: false
					},
					lang: {
						thousandsSep: ','
					},
					yAxis: {
						labels: {
							formatter: function() {
								var len = (Math.max(...yAxisUSD) + "").length;
								if (len >= 7 && len < 10) {
									return '$' + this.value / 1000000 + 'm';
								}
								if (len >= 10) {
									return '$' + this.value / 1000000000 + 'bn';
								}
								if (len < 7) {
									return '$' + this.value;
								}
							}
						},
						title: {
							text: "USD"
						},
						plotLines: [{
							value: 0,
							width: 1,
							color: '#808080'
						}]
					},
					xAxis: {
						categories: xAxisCategories,
						title: {
							text: 'Year'
						}
					},
					tooltip: {
						valuePrefix: '$'
					},
					legend: {
						enabled: false,
						layout: 'vertical',
						align: 'right',
						verticalAlign: 'middle',
						borderWidth: 0
					},
					series: [{
						name: "USD",
						data: dataSeries
					}]
				}}
				/>
				{productionValueNotes  ? 
				<p className="notes-info" style={{marginTop: "auto"}}>
				<em>{productionValueNotes}</em>
				</p>
				:""}
				</>:""}
			</div>
		)
}
export default AnnualProductionValue;